export const environment = {
  production: false,
  apiUrl: 'https://cmgsvcgdocsbulkexportapiappdev01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: 'e6094679-b94a-4fca-a81f-9277c7d23fda',
      authority:
        'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://bc8a4a72-8f67-437b-bb60-0c061d8104f9/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
  enablePhase2: true,
  defaultServiceProviderGuid: '6f85a78e-f7c6-4fb4-9789-52fc16d71e3f',
};
